import React from 'react';
import Message from './Message';
import WaitingForRun from './WaitingForRun';
import Container from 'react-bootstrap/Container';
import ListGroup from 'react-bootstrap/ListGroup';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'configured/axios';
import { useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export default function Thread() {
  const { thread_id } = useParams();
  const [messages, setMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [newMessage, setNewMessage] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(null);
  const [runWaiting, setRunWaiting] = React.useState(false);
  const [runWaitingId, setRunWaitingId] = React.useState(null);

  const loadThread = () => {
    axios.get(`/api/threads/${thread_id}`)
      .then(res => {
        setMessages(
          res.data.remote_messages.data.
          sort( (a,b) => a.created_at - b.created_at )
        );
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load thread');
        setLoading(false);
      });
  }

  React.useEffect(() => {
    setLoading(true);
    setError(null);
    loadThread()
  }, [thread_id]);

  return (
    <Container className="p-3">
      <h3 className="mb-4">Thread</h3>
      {loading && (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {error && (
        <div className="alert alert-danger">{error}</div>
      )}
      {!loading && !error && (
        <>
          <ListGroup variant="flush">
            <>
              {messages.map((msg) => (
                <ListGroup.Item key={msg.id} className="p-0 border-0 bg-transparent">
                  <Message message={msg} />
                </ListGroup.Item>
              ))}
              { runWaiting &&
                <ListGroup.Item key='runWaiting' className='p-0 border-0 bg-transparent'>
                  <WaitingForRun
                    threadId={thread_id}
                    runId={runWaitingId}
                    onRunComplete={ () => {
                      console.log('Thread.WaitingForRun.onRunComplete()')
                      setRunWaiting(false)
                      console.log('Thread.WaitingForRun.onRunComplete: 1')
                      setRunWaitingId(null)
                      console.log('Thread.WaitingForRun.onRunComplete: 2')
                      loadThread()
                    } } />
                </ListGroup.Item>
              }
            </>
          </ListGroup>
          <Form
            className="mt-4"
            onSubmit={async (e) => {
              e.preventDefault();
              if (!newMessage.trim()) return;
              setSubmitting(true);
              setSubmitError(null);
              try {
                const messagePostResult = await axios.post(
                  `/api/threads/${thread_id}/messages`,
                  { body: newMessage }
                );
                setNewMessage("");
                setRunWaiting(true);
                setRunWaitingId(messagePostResult.data.run_remote_id)
              
                // Optionally, reload messages here or optimistically add
              } catch (err) {
                setSubmitError("Failed to send message");
              } finally {
                setSubmitting(false);
              }
            }}
          >
            <Form.Group controlId="newMessage">
              <Form.Control
                type="text"
                placeholder="Type your message..."
                value={newMessage}
                onChange={e => setNewMessage(e.target.value)}
                disabled={submitting}
                autoFocus
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              className="mt-2"
              disabled={submitting || !newMessage.trim()}
            >
              {submitting ? 'Sending...' : 'Send'}
            </Button>
            {submitError && <div className="text-danger mt-2">{submitError}</div>}
          </Form>
        </>
      )}
    </Container>
  );
} 
